/* eslint-disable no-useless-catch */

/**
 * Auth service
 */

// Models
import { LoginRequest } from 'models/LoginRequest';
import { GetAccessTokenRequest } from 'models/GetAccessTokenRequest';
import { RefreshTokenRequest } from 'models/RefreshTokenRequest';

// Constants
import { HTTP_METHOD } from 'utils/constants';

// Configs
import SsoService from 'configs/api/ssoService';

const ENDPOINTS = {
  API_LOGIN: ['/login', HTTP_METHOD.POST],

  API_GET_SERVICES: ['/services', HTTP_METHOD.GET],
  API_GET_USER_INFO: ['/userinfo', HTTP_METHOD.GET],
  API_LOGOUT: ['/logout', HTTP_METHOD.POST],
  API_GET_ACCESS_TOKEN: ['/token', HTTP_METHOD.POST],
  API_REFRESH_TOKEN: ['/token/refresh', HTTP_METHOD.POST],
  API_GET_BANNERS: ['/banners', HTTP_METHOD.GET],
};

class AuthService extends SsoService {
  constructor() {
    super();
  }

  async login(data: LoginRequest) {
    const results = await this.request(ENDPOINTS.API_LOGIN, [], data);
    return results.data;
  }

  async getToken(data: GetAccessTokenRequest) {
    const results = await this.request(ENDPOINTS.API_GET_ACCESS_TOKEN, [], data);
    return results.data?.results;
  }

  async getUserInfo() {
    try {
      const results = await this.request(ENDPOINTS.API_GET_USER_INFO, []);
      return results.data.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
  async getServices() {
    try {
      const results = await this.request(ENDPOINTS.API_GET_SERVICES, []);
      return results.data.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async logout() {
    const results = await this.request(ENDPOINTS.API_LOGOUT, []);
    localStorage.clear();
    return results;
  }

  async refreshToken(data: RefreshTokenRequest) {
    try {
      const results = await this.request(ENDPOINTS.API_REFRESH_TOKEN, [], data);
      return results?.data?.results?.access_token;
    } catch (error: any) {
      throw error;
    }
  }

  async getBanners() {
    try {
      const results = await this.request(ENDPOINTS.API_GET_BANNERS, []);
      return results.data.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default new AuthService();
